import { jsx as r, Fragment as a } from "@emotion/react/jsx-runtime";
import { cloneElement as f } from "react";
import { DynamicBusinessModalButton as p } from "./DynamicBusinessModalButton/DynamicBusinessModalButton.js";
const h = ({
  dataTrackId: s,
  button: n,
  label: i,
  buttonText: l,
  numberOfGroupsSelected: m,
  disabled: o = !1,
  variant: c = "select",
  onClick: e
}) => {
  const t = () => {
    !o && e && e();
  };
  return /* @__PURE__ */ r(a, { children: n ? f(n, {
    onClick: t
  }) : /* @__PURE__ */ r(p, { dataTrackId: s, variant: c, onClick: t, label: i, numberOfGroupsSelected: m, buttonText: l, disabled: o }) });
};
export {
  h as BusinessModalButton
};
